var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status != -1)?_c('div',{staticClass:"StatusTag",on:{"click":_vm.toPath}},[_c('span',{class:{tag:true},style:({backgroundColor:_vm.isError ? _vm.errorStatus[_vm.status].color : _vm.statusMap[_vm.status].color})},[_vm._v(_vm._s(_vm.isError ? _vm.errorStatus[_vm.status].name : '预支付'))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }